import { DateRange } from '../../../types/calendar';
import { useMemo } from 'react';
import { useAppointments } from '../../../query/appointments';
import {
  addDays,
  formatDate,
  getDateTimeOnlyFromISO,
  isInFuture,
  MILLIS_IN_MINUTE,
  parseIsoDate,
} from '../../../utils/dateUtil';
import { groupBy } from 'lodash';

export const useStaffCalendar = ({ dateRange }: { dateRange: DateRange }) => {
  const {
    isLoading: isAppFetching,
    data: appointmentsData,
    dataUpdatedAt,
    refetch,
  } = useAppointments(
    {
      fromDate: formatDate(dateRange.fromDate),
      // We need to add day, as BE looks like cuts of the day before
      toDate: formatDate(addDays(dateRange.toDate, 1)),
      loadUsers: false,
    },
    {
      refetchInterval: 2 * MILLIS_IN_MINUTE,
    },
  );

  const futureAppointmentsSlots = useMemo(() => {
    const withParsed = appointmentsData?.data.data
      ?.filter((data) => isInFuture(parseIsoDate(data.appt_time)))
      ?.map((data) => {
        return {
          appointmentDate: getDateTimeOnlyFromISO(data.appt_time),
          ...data,
        };
      });
    return groupBy(withParsed, 'appointmentDate');
    /**
     * Appointment response is shallow compared, that's why we
     * need the dataUpdatedAt also to verify if cached data items
     * in appointments response have changed
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentsData, dataUpdatedAt]);

  return {
    isFetching: isAppFetching,
    futureAppointmentsSlots,
    refetch,
  };
};
